import React from "react";
import { TextFieldProps } from "@material-ui/core";
import FormErrorMessage from "../../FormErrorMessage/FormErrorMessage";
import Validations from "Modules/Validations";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { FieldErrors } from "react-hook-form";
import { FormField } from "../../FormField/FormField";
import TextFieldWrapper from "../../TextFieldWrapper/TextFieldWrapper";
import { getErrorMessage } from "../utils/getErrorMessage";

type EmailFormFieldProps = {
  errors: FieldErrors;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: any;
};

export const EmailFormField = ({
  errors,
  register,
  ...rest
}: EmailFormFieldProps & TextFieldProps) => {
  const { allowedDomains } = usePartnerConfig();

  return (
    <FormField fieldName="Email Address">
      <TextFieldWrapper
        inputRef={register({
          required: true,
          validate: (value: string) => {
            const validationResult = Validations.emailValidations(
              value,
              allowedDomains
            );
            return typeof validationResult === "string"
              ? validationResult
              : true;
          },
        })}
        name="email"
        {...rest}
      />
      <FormErrorMessage
        showError={!!errors.email}
        labelFor="email"
        message={getErrorMessage("Please enter an email", "email", errors)}
      />
    </FormField>
  );
};
